import { Component } from '@angular/core';

@Component({
  selector: 'app-contact-picture',
  templateUrl: './contact-picture.component.html',
  styleUrls: ['./contact-picture.component.scss'],
})
export class ContactPictureComponent {}
